/**
 * Abhianu Spices - hover to switch product gallery images.
 *
 * Horizon's gallery thumbnails only respond to click. Marketplace listings switch the main image on
 * hover, so this adds hover activation on top of (not instead of) the existing click behaviour.
 *
 * Delegated from the document with `pointerover` so it keeps working after the variant picker morphs
 * or replaces the media gallery. Desktop + real pointer only, so touch scrolling is unaffected.
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 750px)';
  var FINE_POINTER = '(hover: hover) and (pointer: fine)';
  var DELAY = 70;

  var timer = null;
  var pending = null;

  function enabled() {
    if (!window.matchMedia) return false;
    return window.matchMedia(DESKTOP).matches && window.matchMedia(FINE_POINTER).matches;
  }

  function cancel() {
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
    pending = null;
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      if (!enabled()) return;

      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var thumbnail = target.closest('.slideshow-controls__thumbnail');
      if (!thumbnail || !thumbnail.closest('media-gallery')) {
        cancel();
        return;
      }

      if (thumbnail.getAttribute('aria-selected') === 'true') {
        cancel();
        return;
      }

      if (pending === thumbnail) return;

      cancel();
      pending = thumbnail;
      timer = window.setTimeout(function () {
        timer = null;
        if (pending && pending.isConnected) pending.click();
        pending = null;
      }, DELAY);
    },
    true
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (target.closest('.slideshow-controls__thumbnail') === pending) cancel();
    },
    true
  );
})();
